<section class="row" aria-label="Main footer sections">
  <section id="footer_uofe" aria-label="Edina tagline">
    <p><strong>EDINA</strong> is a world-class centre for data and digital expertise at the University of Edinburgh.</p>
  </section>
  <section id="footer_edina" aria-label="Edina address">
    <div class="vcard">
      <p class="adr">
        <span class="organization-unit"><strong>EDINA</strong></span
        ><br />
        <span class="organization-name">The University of Edinburgh</span><br />
        <span class="extended-address">Argyle House</span><br />
        <span class="street-address">3 Lady Lawson Street</span><br />
        <span class="locality">Edinburgh</span><br />
        <span class="postal-code">EH3 9DR</span>
      </p>
    </div>
  </section>

  <section id="footer_noteable" aria-label="Social Media and Service Policies">
    <section class="footer-social-icons" aria-label="Social Media links">
      <a href="https://bsky.app/profile/noteable-edina.bsky.social" rel="external" aria-label="Noteables Bluesky feed"
        ><img src="/images/bluesky_white.svg" alt="Bluesky icon" class="footer-social-icon"
      /></a>
      <a
        href="https://www.youtube.com/channel/UCKhcyiuFyq8xTUlg_DpKIlA"
        rel="external"
        aria-label="Noteables YouTube collection"
        ><img src="/images/youtube.svg" alt="YouTube icon" class="footer-social-icon"
      /></a>
      <a
        href="https://www.linkedin.com/company/noteable-edina/"
        rel="external"
        aria-label="Noteables profile on LinkedIn"
        ><img src="/images/linkedin.svg" alt="LinkedIn icon" class="footer-social-icon"
      /></a>
    </section>
    <section class="footer-links" id="footer-links" aria-label="Links for Service Policies">
      <ul>
        <li><a href="/accessibility/">Accessibility</a></li>
        <li><a href="/cookie-policy/">Cookie policy</a></li>
        <li><a href="/privacy/">Privacy notice</a></li>
        <li><a href="/data-retention/">Data Retention</a></li>
        <li><a href="/usage-policy/">Usage Policy</a></li>
      </ul>
    </section>
  </section>
</section>
<section id="footer_copyright" aria-label="Copyright statement">
  &copy; 2021 The University of Edinburgh. All rights reserved.
</section>
